export const backColors = [
    {bg: 'rgb(240, 247, 255)', border: 'rgb(37, 104, 236)',bgAct: 'rgb(204, 228, 255)'},
    {bg: 'rgb(255, 247, 230)', border: 'rgb(250, 140, 22)',bgAct: 'rgb(255, 231, 186)'},
    {bg: 'rgb(230, 255, 251)', border: 'rgb(19, 194, 194)',bgAct: 'rgb(181, 245, 236)'},
    {bg: 'rgb(249, 240, 255)', border: 'rgb(114, 46, 209)',bgAct: 'rgb(239, 219, 255)'},
    {bg: 'rgb(246, 255, 237)', border: 'rgb(82, 196, 26)',bgAct: 'rgb(217, 247, 190)'},
    {bg: 'rgb(240, 247, 255)', border: 'rgb(37, 104, 236)',bgAct: 'rgb(204, 228, 255)'},
    {bg: 'rgb(255, 247, 230)', border: 'rgb(250, 140, 22)',bgAct: 'rgb(255, 231, 186)'},
    {bg: 'rgb(230, 255, 251)', border: 'rgb(19, 194, 194)',bgAct: 'rgb(181, 245, 236)'},
    {bg: 'rgb(249, 240, 255)', border: 'rgb(114, 46, 209)',bgAct: 'rgb(239, 219, 255)'},
    {bg: 'rgb(246, 255, 237)', border: 'rgb(82, 196, 26)',bgAct: 'rgb(217, 247, 190)'}
]

